module.exports = __webpack_public_path__ + "static/media/gaas-g.52360c8b.mp3";